var styleDataHash = "74adf197";
const injectCss = (() => {
  var css = `.XIdhh{align-items:center;background:#fff;border:1px solid #dfe5eb;border-radius:var(--ricos-internal-textarea-border-radius,24px);box-shadow:0 0 18px 0 rgba(0,6,36,.1),0 6px 6px 0 rgba(0,6,36,0);min-width:320px;overflow:hidden;padding-block:12px;position:relative;transition:padding-bottom .2s ease-in-out}.VRX6-,.XIdhh{display:flex;flex-direction:column}.VRX6-{gap:12px;margin-block-end:12px;padding-inline:12px;width:100%}.xdNWJ .tM6oi{top:calc(100% - 9px);transform:translateY(-100%)}.IdUGX{padding-bottom:54px}.IdUGX .roVPE{overflow-y:scroll;overscroll-behavior:contain;padding-inline:18px}.IdUGX .tM6oi{top:calc(100% - 9px);transform:translateY(-100%)}.tM6oi{display:flex;justify-content:space-between;left:0;padding-inline:12px;pointer-events:none;position:absolute;right:0;top:50%;transform:translateY(-50%);transition:transform .2s ease-in-out,top .2s ease-in-out}.tM6oi.m7gD5{transition:none}.WnOuy{align-items:center;background-color:#fff;box-shadow:0 0 0 3px #fff;display:flex;gap:12px;margin-left:auto;pointer-events:auto}.roVPE{background:transparent;border:none;box-sizing:border-box;flex-shrink:0;font-size:16px;height:24px;line-height:24px;outline:none;overflow-y:hidden;padding-inline-start:18px;resize:none;transition:padding-inline-start .2s ease-in-out,padding-inline-end .2s ease-in-out;width:100%}.roVPE::placeholder{color:#868e96}.roVPE.m7gD5{transition:none}.roVPE._0sNYU{padding-block-start:12px}.XIdhh:not(.IdUGX):not(.m7gD5) .roVPE.dv9Pl{padding-inline-start:60px}.XvU9D{left:9px;overflow-y:scroll;pointer-events:none;position:absolute;right:9px;user-select:none;visibility:hidden;width:calc(100% - 114px)}.m7gD5{transition:none}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var prompt_input_area_default = {
  "root": "XIdhh",
  "topBar": "VRX6-",
  "hasUploadItems": "xdNWJ",
  "actionsContainer": "tM6oi",
  "multiline": "IdUGX",
  "textInput": "roVPE",
  "forceMultiline": "m7gD5",
  "trailing": "WnOuy",
  "hasTopBar": "_0sNYU",
  "allowFileUpload": "dv9Pl",
  "hiddenInput": "XvU9D"
};
export {
  prompt_input_area_default as default,
  injectCss
};
//# sourceMappingURL=prompt-input-area-scss.js.map
